import { useEffect, useState } from "react";

/**
 * `value`, once it has stopped changing for `delayMs`.
 *
 * For a search box: the field itself stays bound to the live value so typing is never
 * laggy, and only the work downstream of it -- filtering, a request -- waits for a pause.
 */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setSettled(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);

  return settled;
}
